import {
  Award,
  BarChart3,
  Bell,
  Briefcase,
  Calendar,
  Clock,
  Crown,
  Download,
  FileText,
  FolderKanban,
  Gift,
  GraduationCap,
  HeartPulse,
  Handshake,
  Info,
  Lock,
  Megaphone,
  MonitorCog,
  MoreHorizontal,
  Newspaper,
  Palmtree,
  PartyPopper,
  PiggyBank,
  Receipt,
  Rocket,
  Scale,
  ServerCrash,
  ShieldAlert,
  ShieldCheck,
  ShieldX,
  Sparkles,
  TrendingUp,
  TriangleAlert,
  UserCog,
  UserPlus,
  Users,
  DollarSign,
  GitBranch,
  Siren,
  Wrench,
  CloudRain,
  MessageSquare,
  type LucideIcon,
} from "lucide-react";

const companyAudio = new Audio("/audio/company-announcement.mp3");

export const announcementIconMap: Record<string, LucideIcon> = {
  Megaphone,
  Crown,
  GitBranch,
  Calendar,
  Users,
  UserCog,
  Gift,
  DollarSign,
  Palmtree,
  UserPlus,
  GraduationCap,
  TrendingUp,
  FileText,
  ShieldCheck,
  Scale,
  Lock,
  TriangleAlert,
  MonitorCog,
  ServerCrash,
  Download,
  Wrench,
  Siren,
  ShieldAlert,
  HeartPulse,
  CloudRain,
  ShieldX,
  FolderKanban,
  Rocket,
  Briefcase,
  BarChart3,
  Handshake,
  Newspaper,
  Award,
  PartyPopper,
  MessageSquare,
  Sparkles,
  PiggyBank,
  Receipt,
  Bell,
  Clock,
  Info,
  MoreHorizontal,
};

export const playAnnouncementSound = () => {
  try {
    companyAudio.currentTime = 0;
    companyAudio.play();
  } catch (err) {
    console.warn("Audio play blocked:", err);
  }
};

export const extractAnnouncementPreview = (html?: string, limit = 50) => {
  if (!html) return "-";

  const el = document.createElement("div");
  el.innerHTML = html;

  let text =
    el.textContent
      ?.replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim() || "";

  if (text.length > limit) {
    text = text.slice(0, limit);
    text = text.slice(0, text.lastIndexOf(" ")) + "...";
  }

  return text;
};
